import React from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { Section, Image, Paragraph, SectionHeader } from 'components';
import './Statistics.scss';

const Statistics = ({ data, mainColor }) => {
  const { caption, counter, image, alt } = data;

  return (
    <Section
      spaceless
      fullwidth
      additionalClass={'cs-statistics'}
      side={'left'}
    >
      <Row className={'no-gap'}>
        <Col sm={12} md={6}>
          <div className={'cs-statistics__image'}>
            <Image src={image} alt={alt} />
          </div>
        </Col>
        <Col sm={12} md={6} className={'cs-statistics__container'}>
          <div className={'section w-container--right cs-statistics__inner'}>
            <SectionHeader
              color={'gray-medium'}
              lineColor={'gray-medium'}
              size={'small'}
            >
              Real impact
            </SectionHeader>
            <div className={'cs-statistics__content'}>
              <span
                className={`cs-statistics__number cs-statistics__number--${mainColor}`}
              >
                {counter}
              </span>
              <Paragraph
                color={'white'}
                size={'medium'}
                additionalClass={'text--default cs-statistics__caption'}
              >
                {caption}
              </Paragraph>
            </div>
          </div>
        </Col>
      </Row>
    </Section>
  );
};

export default Statistics;
